import { Redirect } from 'expo-router';
import { useAtomValue } from 'jotai/index';

import useShouldSeeIncomeSplit from '../../../hooks/income-split/useShouldSeeIncomeSplit';
import { detectedPaychecksAtom } from '../../../state/PaycheckRoutingAtoms';
import { bankAccountDisplayDetails } from '../../../state/SpacesAtoms';
import type { BankAccountDisplayDetail } from '../../../types/BankAccount';
import type { PaycheckRoutingIncomeDetail } from '../../../types/PaycheckRouting';
import NoPaycheckDetected from './NoPaycheckDetected';
import PaycheckSplittingReady from './PaycheckSplittingReady';

const getInfoScreen = (
    paychecks: PaycheckRoutingIncomeDetail[],
    accounts: BankAccountDisplayDetail[],
) => {
    const shouldSeeIncomeSplit = useShouldSeeIncomeSplit();

    if (paychecks.length && accounts.length) {
        if (shouldSeeIncomeSplit ?? accounts.length === 1) {
            return <Redirect href="/home/banking" />;
        }
        return <PaycheckSplittingReady />;
    }

    return <NoPaycheckDetected />;
};

const Info = () => {
    const paychecks: PaycheckRoutingIncomeDetail[] = useAtomValue(
        detectedPaychecksAtom,
    );
    const accounts = useAtomValue(bankAccountDisplayDetails);
    return getInfoScreen(paychecks, accounts);
};

export default Info;
